import axios from 'axios';
import { Helpers } from '../helpers/Helpers';
import { GetDeviceListPagingAndFilterRequest } from '../models/request/device/GetDeviceListPagingAndFilterRequest';
import { AddDeviceRequest } from '../models/request/device/AddDeviceRequest';

export class DeviceService {
    static async getDeviceList() {
        try {
            var inputObj = {

            };

            console.log('SERVICE CALL - getDeviceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/getDeviceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async exportDeviceList(inputObj: GetDeviceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - exportDeviceList', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/exportDeviceList', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDeviceListPagingAndFilter(inputObj: GetDeviceListPagingAndFilterRequest) {
        try {
            console.log('SERVICE CALL - GetDeviceListPagingAndFilter', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/GetDeviceListPagingAndFilter', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async addDevice(inputObj: AddDeviceRequest) {
        try {
            console.log('SERVICE CALL - AddDevice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/AddDevice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async deleteDevice(_ids: string[]) {
        try {
            var inputObj = {
                ids: _ids
            };

            console.log('SERVICE CALL - deleteDevice', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/deleteDevice', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }

    static async getDeviceById(_id: string) {
        try {
            var inputObj = {
                id: _id
            };

            console.log('SERVICE CALL - getDeviceById', JSON.stringify(inputObj));

            const resp = await axios.post(Helpers.getEndpoint() + '/Device/getDeviceById', inputObj);

            return Helpers.dataParser(resp);
        } catch (error) {
            throw Helpers.parseErrorMessage(error);
        }
    }
}